// src/components/Auth/Auth.js
import React, { useState } from 'react';
import { auth } from '../../firebase'; // Import auth
import { signInWithEmailAndPassword } from 'firebase/auth'; // For login
import { useNavigate } from 'react-router-dom';

function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Logged in successfully!");
      navigate("/admin"); // Redirect to admin dashboard after successful login
    } catch (err) {
      console.error("Login failed:", err.message);
      setError('Login failed: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={loginContainerStyle}>
      <h2 style={loginHeadingStyle}>Admin Login</h2>
      <form onSubmit={handleLogin} style={loginFormStyle}>
        {error && <p style={errorStyle}>{error}</p>}
        <div style={formGroupStyle}>
          <label htmlFor="email" style={labelStyle}>Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
            required
          />
        </div>
        <div style={formGroupStyle}>
          <label htmlFor="password" style={labelStyle}>Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            required
          />
        </div>
        <button type="submit" style={loginButtonStyle} disabled={loading}>
          {loading ? 'Logging In...' : 'Log In'}
        </button>
      </form>
    </div>
  );
}

// --- Basic styles for login page ---
const loginContainerStyle = {
  maxWidth: '400px',
  margin: '50px auto',
  padding: '30px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  backgroundColor: '#fff',
  fontFamily: 'Arial, sans-serif',
};

const loginHeadingStyle = {
  textAlign: 'center',
  color: '#333',
  marginBottom: '20px',
};

const loginFormStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
};

const formGroupStyle = {
  marginBottom: '10px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
  color: '#555',
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontSize: '1em',
};

const loginButtonStyle = {
  padding: '12px 20px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  fontSize: '1.1em',
  fontWeight: 'bold',
  transition: 'background-color 0.3s ease',
};
loginButtonStyle[':hover'] = {
  backgroundColor: '#0056b3',
};

const errorStyle = {
  color: 'red',
  textAlign: 'center',
  marginBottom: '10px',
};

export default Auth;